import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <main className="fallback-page">
      <p>这里还没有关卡。</p>
      <Link to="/">返回游戏</Link>
    </main>
  );
}
